import { render, staticRenderFns } from "./DeviceStatusByClient.vue?vue&type=template&id=17f848ae&scoped=true&"
import script from "./DeviceStatusByClient.vue?vue&type=script&lang=js&"
export * from "./DeviceStatusByClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f848ae",
  null
  
)

export default component.exports